import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Button, Container, NavDropdown } from "react-bootstrap";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { IoMenu, IoClose, IoCallOutline } from "react-icons/io5"; // Icons for mobile menu
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { HashLink } from "react-router-hash-link";
import { Icon } from "@iconify/react/dist/iconify.js";
import Login from "../components/auth/login/Login";
import axios from "axios";
import toast from "react-hot-toast";
import { getCookie } from "../components/auth/login/GetCookie";
import Cookies from 'js-cookie';
// import logo2 from '../Assets/Images/logo2.png'
// import logo1 from '../Assets/Images/logo.png'
import logo1 from '../Assets/Images/Gravinora.png'


const NavbarComponent = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [readNotifications, setReadNotifications] = useState(new Set());
    const [showDropdown, setShowDropdown] = useState(false);
    const [loginopen, setloginopen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    useEffect(() => {
        // const token = localStorage.getItem("token");
        const token = getCookie("token");
        setIsLoggedIn(!!token);
        fetchnotification();
        // const interval = setInterval(fetchnotification, 5000); // Poll every 5s
        // return () => clearInterval(interval);
    }, []);



    const markAsRead = async (notificationId) => {
        const notification = notifications.find((notif) => notif.notificationId === notificationId);

        if (!notification) {
            toast.error("Notification not found!");
            return;
        }

        if (notification.read) {
            toast.error("Already marked as read.");
            return;
        }

        try {
            //   const token = localStorage.getItem('token');
            const token = getCookie("token");
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications/${notificationId}/mark-read`,
                {}, // Assuming no body is required
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // Update local state after successful API call
            setNotifications((prev) =>
                prev.map((notif) =>
                    notif.notificationId === notificationId ? { ...notif, read: true } : notif
                )
            );

            setReadNotifications((prev) => {
                const updatedRead = new Set(prev).add(notificationId);
                //   localStorage.setItem("readNotifications", JSON.stringify([...updatedRead]));
                Cookies.set("readNotifications", JSON.stringify([...updatedRead]));
                return updatedRead;
            });

            toast.success("Notification marked as read!");
        } catch (error) {
            console.error("Error marking notification as read:", error);
            toast.error("Failed to mark notification as read.");
        }
    };

    const fetchnotification = async () => {
        // const token = localStorage.getItem('token');
        const token = getCookie("token");

        // if (!token) {
        //     toast.error("Invalid token");
        //     return;
        // }



        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const allNotifications = response.data;

            // Filter only INQUIRY_REPLY notifications
            const filteredNotifications = allNotifications.filter(
                (notif) => notif.notificationType === "INQUIRY_REPLY"
            );



            if (Array.isArray(filteredNotifications)) {
                console.log("Notification IDs:", filteredNotifications.map((notif) => notif.notificationId));
                console.log("Notification status:", filteredNotifications.map((notif) => notif.read));
            }
            setNotifications(filteredNotifications);

        } catch (error) {
            console.error("Error Fetching Notification:", error);
        } finally {
        }
    };
    function handleOpenLogin() {
        setloginopen(true);
    }
    // Function to close login modal
    const handleCloseLogin = () => setloginopen(false);

    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const cookieOptions = {
        //secure: process.env.NODE_ENV === 'production', // Secure in production
        // sameSite: 'strict',
        sameSite: 'Lax',   // ✅ best choice for HTTP
        path: '/',
        expires: 1 // 1 day expiration
    };

    const handleLogout = () => {
        // localStorage.removeItem('token');
        // localStorage.clear();
        // Remove cookies
        // Remove all auth cookies
        Cookies.remove('token', cookieOptions);
        Cookies.remove('roles', cookieOptions);
        Cookies.remove('user', cookieOptions);
        // Determine where user logged in from
        const loginOrigin = Cookies.get("loginOrigin");
        Cookies.remove("loginOrigin");
        setIsLoggedIn(false);
        console.log("logout successfully === nav bar")
        toast.success("Logout Successfully!", { duration: 10000 })
        window.location.reload();
        const BASE_URL = process.env.REACT_APP_ADMIN_lOGOUT_URL
        const BASE_URL_BUYER = process.env.REACT_APP_BUYER_URL

        // Redirect
        if (loginOrigin === "admin") {
            window.location.href = BASE_URL; //ADMIN
        } else {
            window.location.href = BASE_URL_BUYER; //BUYER
        }

    };


    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <Navbar expand="lg" className="fixed-navbar shadow px-4"
            style={{ background: '#371300' }}>
            <Container fluid>
                {/* Logo */}

                <Navbar.Brand as={Link} to="/">
                    <div className="d-flex align-items-center d-lg-none justify-content-center">
                        <div className="">
                            <img src={logo1} alt="Logo" style={{
                                height: '37px', width: '103px',
                                // borderRadius: '50%',
                                marginTop: '4px'
                            }} />
                        </div>
                        {/* <span className="ms-2 fw-bold logo-text">VANGUARD</span> */}
                    </div>
                </Navbar.Brand>

                {/* Contact Us Button & Menu Icon for Mobile */}
                <div className="d-flex align-items-center gap-2">
                    <Button onClick={() => navigate("/#contact-section")}
                        className="create-btn rounded-pill d-lg-none ">
                        Contact Us
                    </Button>

                    {/* Notification on large screen */}
                    {isLoggedIn && (
                        <div className=" notification-Icon d-lg-none  ">
                            <div onClick=

                                {() => setShowDropdown(!showDropdown)}
                            >
                                <Icon
                                    icon="mdi:bell-outline"
                                    className="fs-4 cursor-pointer position-relative"

                                />

                                {notifications.some(n => !n.read) && (
                                    <span className="">
                                        <Icon icon="icon-park-outline:dot" className="noti-no" />
                                    </span>
                                )}

                            </div>


                            {showDropdown && (
                                <div
                                    ref={dropdownRef}
                                    className="dropdown-menu dropdown-menu-end show p-2 shadow"
                                    style={{
                                        width: "300px",
                                        position: "absolute",
                                        right: 150,
                                        top: "76px",
                                        zIndex: 1000,
                                    }}
                                >
                                    <button className='view-btn float-end px-2'
                                        onClick={() => {
                                            setShowDropdown(false);
                                            navigate('/notification')
                                        }}
                                        style={{ fontSize: '14px', cursor: 'pointer' }}>
                                        View All
                                        <Icon icon='weui:arrow-filled' className='fs-4 ps-1' />
                                    </button>
                                    <h6 className="fw-bold">Notifications</h6>
                                    <ul className="list-unstyled m-0">
                                        {notifications.length > 0 ? (
                                            notifications.map((n, index) => (
                                                <li
                                                    key={index}
                                                    className="d-flex align-items-start p-2 cursor-pointer"
                                                    onClick={() => {
                                                        if (!readNotifications.has(n.notificationId)) {
                                                            markAsRead(n.notificationId);
                                                        }
                                                        setShowDropdown(false);
                                                    }}
                                                >
                                                    {/* Icon */}
                                                    <div className="me-2">
                                                        <div
                                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: "40px", height: "40px",
                                                                background: '#d9ffd2'
                                                            }}
                                                        >
                                                            {n.notificationType === "NEW_PRODUCT" ? (
                                                                <Icon icon='ph:package' className="fs-5" style={{ color: '#FDC400' }} />

                                                            ) : (
                                                                <Icon icon='carbon:document' className=" fs-5" style={{ color: '#FDC400' }} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Notification Content */}
                                                    <div className="w-100 ">

                                                        <p
                                                            className="msg-title m-0"
                                                            style={{
                                                                fontWeight: n.read ? "500" : "600",
                                                                color: n.read ? "#FDC400" : "#303030",
                                                            }}
                                                        >
                                                            {n.notificationType === "NEW_PRODUCT" ? "New Product Added!" : "New Enquiry Received!"}
                                                        </p>


                                                        <p className="msg-Noti m-0">{n.message}</p>
                                                    </div>
                                                </li>
                                            ))
                                        ) : (
                                            <p className="text-muted text-center">No notifications</p>
                                        )}
                                    </ul>

                                </div>
                            )}
                        </div>
                    )}



                    <Button variant="link" className="d-lg-none menu-icon" onClick={toggleMenu}>
                        {menuOpen ? <IoClose className="menu-btn" /> : <IoMenu className="menu-btn" />}
                    </Button>
                </div>



                {/* Large Screen Navigation Links */}
                <Navbar.Collapse id="basic-navbar-nav" className="d-none mt-2 d-lg-flex">
                    <Nav className="ms-auto align-items-center">
                        <Link to="/"
                            onClick={scrollToTop}
                            className={`nav-link-text px-lg-4 px-sm-2 
                        ${location.pathname === '/' ? 'active' : ''}`}
                            activeClassName="active" >Home</Link>
                        <Link className="nav-link-text px-lg-4 px-sm-2" activeClassName="active"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate("/#about-section");
                            }}
                        >About Us</Link>
                        <Link to="/events" className="nav-link-text px-lg-4 px-sm-2" activeClassName="active">Events</Link>
                        <Link to="/blogs" className="nav-link-text px-lg-4 px-sm-2" activeClassName="active">Blogs</Link>
                    </Nav>

                    {/* Large Screen Contact Button & Auth Buttons */}
                    <div className="d-flex gap-2">
                        <Button onClick={() => navigate("/#contact-section")} className="contact-btn1 rounded-pill d-none d-lg-inline-block">
                            Contact Us
                        </Button>
                    </div>
                </Navbar.Collapse>

                {/* Small Box Menu for Mobile */}

                {menuOpen && (
                    <div className="mobile-menu-box">
                        <Nav className="d-flex flex-column">
                            {/* Navigation Links */}
                            <Link to="/" className="nav-link-text" onClick={() => setMenuOpen(false)}>Home</Link>
                            <Link to="/about" className="nav-link-text"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/#about-section");
                                    setMenuOpen(false)
                                }}
                            >About Us</Link>
                            <Link to="/events" className="nav-link-text" onClick={() => setMenuOpen(false)}>Events</Link>
                            <Link to="/blogs" className="nav-link-text" onClick={() => setMenuOpen(false)}>Blogs</Link>

                            {/* Contact Number */}
                            <Link to="/" className="d-flex nav-link-text align-items-center contact-link"
                            >
                                <IoCallOutline className="me-2" fontSize={24} />
                                +12345 67890
                            </Link>

                            {/* Profile Dropdown (if logged in) */}
                            {isLoggedIn ? (
                                <div
                                >
                                    <Link to="/profile" className='fs-6 fw-normal nav-link-text'
                                        onClick={() => setMenuOpen(false)}>
                                        Account
                                        <Icon icon="mingcute:right-line" className='fs-5 float-end' />
                                    </Link>
                                    <NavDropdown.Divider />
                                    {/* <Link to="/membership" className='fs-6 fw-normal  nav-link-text'>
                        Membership
                        <Icon icon="mingcute:right-line" className='fs-5 float-end' />
                    </Link> */}
                                    <NavDropdown.Divider />
                                    <Link className='text-danger fs-6 fw-normal nav-link-text'
                                        onClick={(e) => {
                                            //alert("Model Show")
                                            setShowLogoutModal(true); // Show confirmation modal
                                            e.preventDefault();  // Prevent default behavior


                                        }}
                                    >
                                        Logout
                                    </Link>
                                </div>
                            ) : (
                                <>
                                    {/* Login & Register Buttons */}
                                    <Button className="login-btn w-100 mb-2" onClick={handleOpenLogin}>Login</Button>

                                    <Link to="/register" className="text-decoration-none">
                                        <Button className="create-btn w-100 mt-3">Create an account</Button>
                                    </Link>
                                </>
                            )}
                        </Nav>
                    </div>
                )}

            </Container>
            {loginopen && <Login onClose={handleCloseLogin} loginopen={loginopen} />}

            {showLogoutModal && (
                <div
                    className="modal show d-block d-flex justify-content-center align-items-center"
                    style={{
                        boxShadow: '0px 4px 6px 0px #00000026',
                        background: '#000000B2',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-sm modal-md modal-lg modal-xl modal-xxl w-100 mx-3 mx-sm-5" style={{ maxWidth: '600px' }}>
                        <div className="modal-content pt-4">
                            <div className="d-flex justify-content-end px-3">
                                <Icon
                                    icon="material-symbols-light:close"
                                    className="close-btn fs-5"
                                    onClick={() => setShowLogoutModal(false)}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                            <h5 className="pt-4 fw-bold fs-5 px-4 text-center">Logout Confirmation</h5>
                            <p className="px-4 fw-normal fs-6 text-center" style={{ color: '#606060' }}>
                                Are you sure you want to logout?
                            </p>
                            <div className="d-flex justify-content-center align-items-center gap-3 gap-md-4 mt-2 mb-5 flex-wrap">
                                <button
                                    className="rounded-5 border cancelbtn px-4 py-2 px-md-5"
                                    onClick={() => setShowLogoutModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-4 py-2 px-md-5 rounded-5 border"
                                    style={{
                                        background: '#371300',
                                        color: '#FFFFFF',
                                    }}
                                    onClick={handleLogout}
                                >
                                    Yes, Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </Navbar>
    );
};

export default NavbarComponent;



